import { ReactNode, KeyboardEvent } from "react";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";

export interface TryIntentProps {
    children: ReactNode;
    intentType: "button" | "form" | "demo" | "buy";
    containerId?: string;
    productKey?: string;
    edition?: string;
    onAnalyticsEventFired?: () => void;
}

export const TryIntent = ({
    children,
    intentType,
    containerId,
    productKey,
    edition,
    onAnalyticsEventFired
}: TryIntentProps) => {
    const { createAnalyticsEvent } = useAnalyticsEvents();
    const onTryIntentClick = () => {
        createAnalyticsEvent({
            eventType: "track",
            action: "interacted",
            actionSubject: "tryIntentComponent",
            containerId: containerId,
            actionSubjectId: intentType,
            attributes: {
                productKey: productKey,
                edition: edition
            }
        }).fire();
        onAnalyticsEventFired && onAnalyticsEventFired();
    };
    const onKeyDown = (e: KeyboardEvent) => {
        if (e.code !== "Tab" && e.code !== "Enter" && e.code !== "Space") {
            createAnalyticsEvent({
                eventType: "track",
                action: "interacted",
                actionSubject: "tryIntentComponent",
                containerId: containerId,
                actionSubjectId: intentType,
                attributes: {
                    productKey: productKey,
                    edition: edition
                }
            }).fire();
            onAnalyticsEventFired && onAnalyticsEventFired();
        }
    };

    return (
        // This is just a wrapper that doesn't affect user interactivity. Okay to ignore this a11y rule.
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        <div
            data-testid={"try-intent-wrapper"}
            onKeyDown={onKeyDown}
            onClick={onTryIntentClick}
        >
            {children}
        </div>
    );
};

export default TryIntent;
